<div class="report-time">
  <div class="flex p-b-sm">{{ 'REPORTS.date_selection' | translate }}</div>
  <div class="data-time-block b-a">
    <div class="btn-group-row">
      <div class="btn-group">
        <button class="btn btn-sm btn-outline-default"
                [class.active]="selectedDateType === ReportTimeDateType.SINGLE_DATE"
                (click)="onChangeType(ReportTimeDateType.SINGLE_DATE)">
          {{'REPORTS.date' | translate}}
        </button>
        <button class="btn btn-sm btn-outline-default"
                [class.active]="selectedDateType === ReportTimeDateType.BETWEEN_DATES"
                (click)="onChangeType(ReportTimeDateType.BETWEEN_DATES)">
          {{ 'REPORTS.period' | translate }}
        </button>
      </div>
    </div>
    <form novalidate [formGroup]="singleDateForm">
      <div *ngIf="selectedDateType === ReportTimeDateType.SINGLE_DATE" class="p-a-sm m-b-0">
        <div class="form-group m-b-sm">
          <select class="form-control" formControlName="singleDateOptionCtrl" (change)="onDateChange()">
            <option *ngFor="let item of singleDateOptions"
                    [value]="item.id">
              {{ item.text | translate }}
            </option>
          </select>
        </div>
        <div class="form-group m-b-xs">
          <datepicker-input [isAppendToBody]="true"
                            [readOnly]="isDateReadonly"
                            [hasEternity]="true"
                            formControlName="beginDateControl">
          </datepicker-input>
        </div>
      </div>
    </form>
    <form novalidate [formGroup]="betweenDatesForm">
      <div *ngIf="selectedDateType === ReportTimeDateType.BETWEEN_DATES" class="p-a-sm m-b-0">
        <div class="form-group m-b-sm">
          <select class="form-control" formControlName="betweenDatesOptionCtrl" (change)="onDateChange()">
            <option *ngFor="let item of betweenDateOptions"
                    [value]="item.id">
              {{ item.text | translate }}
            </option>
          </select>
        </div>
        <div class="form-group m-b-sm">
          <datepicker-input [isAppendToBody]="true"
                            [hasEternity]="true"
                            [readOnly]="isDateReadonly"
                            formControlName="beginDateControl">
          </datepicker-input>
        </div>
        <div class="form-group m-b-xs">
          <datepicker-input [isAppendToBody]="true"
                            [hasEternity]="true"
                            [readOnly]="isDateReadonly"
                            formControlName="endDateControl">
          </datepicker-input>
        </div>
      </div>
    </form>
  </div>

</div>
